module.exports = __webpack_public_path__ + "media/categories-photos/28-3606c4ce.webp";